<template>
<div class="h-100">
    <div class="box-page" key="tran1">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">สัญญาซื้อขาย</span>
                
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
                <div class="ml-4">
                    <div class="circle_green" style="display:inline-block; margin-right:10px;"></div>สัญญายังมีผลบังคับใช้อยู่
                    <div class="circle_black" style="display:inline-block; margin-right:10px; margin-left:10px;"></div>สัญญาถูกปิดเรียบร้อยแล้ว
                    <div class="circle_red" style="display:inline-block; margin-right:10px; margin-left:10px;"></div>สัญญาถูกปฏิเสธหรือถูกยกเลิก
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อ" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 230px; min-width: 230px;">
                            </th>
                            <th style="width: 45px; min-width: 45px;">
                                <div class="text-btn header-text text-center">
                                    <span>สถานะสัญญา</span>
                                </div>
                            </th>
                            <th style="width: 70px; min-width: 70px;">
                                <div class="text-btn header-text text-center">
                                    <span>ลำดับ</span>
                                </div>
                            </th>
                            <th style="width: 100px; min-width: 100px;">
                                <div class="text-btn header-text text-center">
                                    <span>เลขที่สัญญา</span>
                                </div>
                            </th>
                            <th style="width: 90px; min-width: 90px;">
                                <div class="text-btn header-text text-center">
                                    <span>สถานะเครดิตบูโร</span>
                                </div>
                            </th>
                            <th style="width: 130px; min-width: 130px;">
                                <div class="text-btn header-text text-center">
                                    <span>วันที่สร้าง</span>
                                </div>
                            </th>
                            <th style="width: 130px; min-width: 130px;">
                                <div class="text-btn header-text text-center">
                                    <span>เริ่มวันที่ชำระ</span>
                                </div>
                            </th>
                            <th style="width: 130px; min-width: 130px;">
                                <div class="text-btn header-text text-center">
                                    <span>ถึงวันที่ชำระ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ผู้ซื้อ</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ผู้ขาย</span>
                                </div>
                            </th>
                            <th style="width: 180px;">
                                <div class="text-btn header-text text-right">
                                    <span>จำนวนเงิน</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listContract" :key="idx">
                            <td class="align-middle">
                                <div class="show-on-hover">
                                    <div class="btn-group">
                                        <button class="btn btn-table" @click.stop="gotoDetailPage(item.id)">แสดงประวัติการชำระเงิน</button>
                                        <!-- <a href="#" class="btn btn-table" @click="showDetail(item.id, item)" :disabled="item.disabled">รายละเอียด</a> -->
                                    </div>
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" href="">
                                            <img height="24" src="../../../../assets/img/icons/threedots.png" />
                                        </a>
                                        <div class="dropdown-menu">
                                            <button class="dropdown-item" @click.stop="showPDF(item.id)">ดูเอกสาร</button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <div v-if="item.status == 'active'" class="circle_green"></div>
                                <div v-else-if="item.status == 'ended'" class="circle_black"></div>
                                <div v-else class="circle_red"></div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.contract_no"></span>
                            </td>
                            <td class="text-center">
                                <span class="tag-staff" :class="item.status_css" v-text="item.status_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.created_at_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.start_due_date_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.end_due_date_text"></span>
                            </td>
                            <td class="text-left">
                                <!-- <img :src="getSrcImageMember(item.borrower_avatar)" class="icon-avatar"> -->
                                <span class="ml-2" v-text="item.borrower_name"></span>
                            </td>
                            <td class="text-left">
                                <!-- <img :src="getSrcImageMember(item.lender_avatar)" class="icon-avatar"> -->
                                <span class="ml-2" v-text="item.lender_name"></span>
                            </td>
                            <td class="text-right">
                                <span v-text="item.amount"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>
    <div class="modal-group" key="tran2">
        <div id="modal_detail" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">สัญญาซื้อขาย <span v-text="detail.contract_no"></span></h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input" v-model="detail.loanerName" readonly>
                                        <label for="" class="ele-textbox-label">ชื่อผู้ซื้อ</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input" v-model="detail.lenderName" readonly>
                                        <label for="" class="ele-textbox-label">ชื่อผู้ขาย</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input" v-model="detail.thingName" readonly>
                                        <label for="" class="ele-textbox-label">ชื่อรายการสินค้า</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.downPayment" readonly>
                                        <label for="" class="ele-textbox-label">เงินดาวน์/เงินมัดจำ (บาท)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.amount" readonly>
                                        <label for="" class="ele-textbox-label">จำนวนเงินที่ขอกู้ (บาท)</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.interest_rate" readonly>
                                        <label for="" class="ele-textbox-label">ดอกเบี้ย (บาท)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.lender_fee" readonly>
                                        <label for="" class="ele-textbox-label">ค่าธรรมเนียมผู้ให้กู้ (บาท)</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.paymentDate " readonly>
                                        <label for="" class="ele-textbox-label">ชำระเงินทุกวันที่</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.fee" readonly>
                                        <label for="" class="ele-textbox-label">ค่าธรรมเนียม (บาท)</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.amountPeriod" readonly>
                                        <label for="" class="ele-textbox-label">จำนวนงวด (งวด)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ele-textbox">
                                        <input type="text" class="ele-textbox-input text-right" v-model="detail.paymentPerPeriod" readonly>
                                        <label for="" class="ele-textbox-label">ชำระเงินงวดละ (บาท)</label>
                                    </div>
                                </div>
                            </div>

                            <label for="" class="ele-textbox-label">รูปสินค้า</label>
                            <div class="row">
                                <div class="col-md-6 py-4 text-center" v-for="(itm, idx) in detail.image_urls" :key="idx">
                                    <img :src="baseUrl + itm" class="w-100 h-100">
                                    <label>รูปที่ {{ idx + 1 }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ปิด</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import PaginationComponent from './../../sub_components/PaginationComponent';
    import DefaultNoAvatar from '../../../../assets/img/avatar.png';
    import Loading from 'vue-loading-overlay';
    Vue.use(Loading);
    export default {
        components: {
            PaginationComponent,
            Loading
        },
        props: {
            baseUrl: {
                default: window.BASE_URL
            }
        },
        data: function () {
            return {
                listContract: [],
                keyword: '',
                startDate: null,
                endDate: null,
                totalPage: 1,
                totalItems: 0,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                detail: {
                    loanerName: '',
                    lenderName: '',
                    thingName: '',
                    downPayment: '',
                    amount: '',
                    interest_rate: '',
                    duration: '',
                    paymentDate: '',
                    lender_fee: '',
                    fee: '',
                    amountPeriod: '',
                    paymentPerPeriod: '',
                    image_urls: [],
                },
                loader: null,
            }
        },
        mounted() {
        },
        created() {
            this.buildJquery();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
        },
        methods: {
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            showLoading() {
                this.loader = this.$loading.show({
                  canCancel: false,
                });
            },
            hideLoading() {
                if (this.loader != null) {
                  this.loader.hide();
                }
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    type: 'thing'
                };
                axios.post(`${this.baseUrl}/admin/contract/api/list`, params).then(({ data }) => {
                    const rows = (data != null && Array.isArray(data.data)) ? data.data : [];
                    if (rows.length > 0) {
                        rows.forEach(item => {
                            item.start_due_date_text = !!item.start_due_date ? moment(item.start_due_date).format('DD/MM/YYYY') : '-';
                            item.end_due_date_text = !!item.end_due_date ? moment(item.end_due_date).format('DD/MM/YYYY') : '-';
                            item.created_at_text = !!item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '-';
                            item.status_css = 'active-0';
                        });
                    }
                    this.totalItems = (parseInt((data && data.total), 10) || 0);
                    this.lastPage = (parseInt((data && data.totalPage), 10) || 1);
                    this.listContract = rows;

                    this.$nextTick(() => {
                        if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                            this.$refs.pagination.bindListPageNo();
                        }
                    });
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            showDetail(loanId, item) {
                item.disabled = true;
                this.showLoading();
                axios.post(`${this.baseUrl}/admin/contract/api/detail`, {
                    id: loanId
                }).then(({ data }) => {
                    const d = data.data;
                    this.detail.contract_no = d.contract_no ? '#' + d.contract_no : '';
                    this.detail.loanerName = d.borrower_name;
                    this.detail.lenderName = d.lender_name;
                    this.detail.thingName = d.thing_name;
                    this.detail.downPayment = d.down_payment;
                    this.detail.amount = d.amount;
                    this.detail.interest_rate = d.interest_rate_text;
                    this.detail.duration = d.duration;
                    this.detail.paymentDate = d.pay_date;
                    this.detail.lender_fee = d.lender_fee;
                    this.detail.fee = d.fee;
                    this.detail.amountPeriod = d.paymentPeriod;
                    this.detail.paymentPerPeriod = d.paymentPerPeriod;
                    this.detail.image_urls = d.image_urls;
                    $('#modal_detail').modal('show');
                }).catch(error => console.log('error : ' + error))
                .then(() => {
                    this.hideLoading();
                });
            },
            getSrcImageMember(avatar) {
                if (avatar) {
                    return avatar;
                } else {
                    return DefaultNoAvatar;
                }
            },
            showPDF(id) {
                window.open(this.baseUrl + '/admin/contract/view-pdf/' + id);
            },
            gotoDetailPage(id) {
                location.href = this.baseUrl + '/admin/contract/detail/' + id;
            },
        },
    }
</script>

<style lang="scss" scoped>

    .circle_black {
        background: #000;
        width: 6px;
        height: 6px;
        margin: 0 auto;
        border-radius: 50%;
        margin-top: 10px;
    }

    .circle_red {
        background: #f00;
        width: 6px;
        height: 6px;
        margin: 0 auto;
        border-radius: 50%;
        margin-top: 10px;
    }

    .circle_green {
        background: #0f0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 10px;
    }

    .icon-avatar {
        height: 24px;
        width: 24px;
        border-radius: 50%;
    }
    .tag-staff {
        display: inline-block;
        min-width: 80px;
        padding: 0;
        line-height: 24px;
        &.active-0 {
            background-color: #01df01;
        }
        &.active-31 {
            background-color: #ff8000;
        }
        &.active-61 {
            background-color: #ff0000;
        }
        &.active-90 {
            background-color: #385858;
        }
    }
</style>




